import React from 'react';
import { Button } from '../../../common-components/Button/Button';
import { strings } from '../../../resources/strings';

interface IActionsForDnpLinksProps {
    filtering?: boolean;
    updateList?: () => void;
    getNewLink?: () => void;
}

const ActionsForDnpLinks: React.FC<IActionsForDnpLinksProps> = ({
    filtering,
    updateList,
    getNewLink
}) => {

    return (
        <>
            <Button text={strings.UpdateList} disabled={filtering} marginRight={'3px'} marginLeft={'3px'} minWidth={'140px'} click={updateList} /> 
            <Button text={strings.GetNewLink} disabled={filtering} marginRight={'3px'} marginLeft={'3px'} minWidth={'140px'} click={getNewLink} /> 
        </>
    );
}

export {ActionsForDnpLinks};